import { Theme, styled, Box as MuiBox } from "@mui/material";
import { ContainerProps } from "./DateRangePicker.props";

export const Container = styled((props: ContainerProps) => <MuiBox {...props} />, {
  shouldForwardProp: (prop) => prop !== "topOffset"
})(
  ({ theme: { breakpoints }, topOffset }) => `
    &.MuiBox-root {
      position: fixed;
      top: ${topOffset + 88}px;
      right: 32px;
      z-index: 1000;

      ${breakpoints.up("md")} {
        top: ${topOffset + 104}px;
        right: 40px;
      }
    }
  `
);

export const makePopperStyles = ({
  palette: {
    custom: { blue, white, turquoise, grey }
  },
  typography: { body2 }
}: Theme) => ({
  "& .MuiPaper-root": {
    backgroundColor: blue.main,
    color: white.main,

    "& .MuiPickersArrowSwitcher-root": {
      "& .MuiButtonBase-root": {
        color: white.main
      }
    },

    "& .MuiDayCalendar-weekDayLabel": {
      color: white.light,
      fontSize: body2.desktop.fontSize,
      fontWeight: 500,
      lineHeight: body2.desktop.lineHeight
    },

    "& .MuiDayCalendar-weekContainer": {
      margin: 0
    },

    "& .MuiDateRangePickerDay-root": {
      "&:nth-last-of-type": {
        borderRadius: 0,

        "& .MuiDateRangePickerDay-rangeIntervalDayPreview": {
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0
        }
      },

      "&:first-of-type": {
        borderRadius: 0,

        "& .MuiDateRangePickerDay-rangeIntervalDayPreview": {
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0
        }
      },

      "&.MuiDateRangePickerDay-rangeIntervalDayHighlight": {
        backgroundColor: blue.light,

        "& .MuiPickersDay-dayOutsideMonth": {
          color: grey.darkest,

          "&.Mui-selected": {
            backgroundColor: turquoise.dark,
            width: "28px",
            height: "28px",
            margin: "4px",
            color: white.main
          }
        }
      },

      "&.MuiDateRangePickerDay-rangeIntervalDayHighlightEnd": {
        borderTopRightRadius: "50%",
        borderBottomRightRadius: "50%"
      },

      "&.MuiDateRangePickerDay-rangeIntervalDayHighlightStart": {
        borderTopLeftRadius: "50%",
        borderBottomLeftRadius: "50%"
      },

      "&.MuiDateRangePickerDay-startOfMonth": {
        "& .MuiDateRangePickerDay-rangeIntervalDayPreview": {
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
          borderLeft: `none`,
          paddingLeft: "2px"
        }
      },

      "&.MuiDateRangePickerDay-endOfMonth": {
        "& .MuiDateRangePickerDay-rangeIntervalDayPreview": {
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderRight: `none`,
          paddingRight: "2px"
        }
      },

      "& .MuiDateRangePickerDay-rangeIntervalDayPreview": {
        borderTop: `2px solid ${turquoise.dark}`,
        borderBottom: `2px solid ${turquoise.dark}`,
        borderRight: `none`,
        borderLeft: `none`,
        boxSizing: "border-box",
        padding: "0 2px",

        "&.MuiDateRangePickerDay-rangeIntervalDayPreviewEnd": {
          borderRight: `2px solid ${turquoise.dark}`,
          borderTopRightRadius: "50%",
          borderBottomRightRadius: "50%",
          paddingRight: "0"
        },

        "&.MuiDateRangePickerDay-rangeIntervalDayPreviewStart": {
          borderLeft: `2px solid ${turquoise.dark}`,
          borderTopLeftRadius: "50%",
          borderBottomLeftRadius: "50%",
          paddingLeft: "0"
        }
      },

      "& .MuiButtonBase-root": {
        color: white.main,
        fontSize: body2.desktop.fontSize,
        fontWeight: 500,
        lineHeight: body2.desktop.lineHeight,
        transform: "none",

        "&:hover": {
          color: white.main,
          border: "none"
        }
      },

      "& .Mui-selected": {
        backgroundColor: turquoise.main,
        width: "28px",
        height: "28px",
        margin: "4px"
      },

      "& .MuiPickersDay-dayOutsideMonth": {
        color: blue.light
      },

      "& .MuiDateRangePickerDay-rangeIntervalDayHighlight": {
        color: white.light
      },

      "&:nth-last-of-type(-n+2)": {
        "& .MuiButtonBase-root": {
          color: white.light,

          "&.Mui-selected": {
            color: white.main
          }
        },

        "&.MuiDateRangePickerDay-rangeIntervalDayHighlight": {
          "& .MuiPickersDay-dayOutsideMonth": {
            color: white.light
          }
        },

        "& .MuiPickersDay-dayOutsideMonth": {
          color: blue.light
        }
      },

      "& .MuiPickersDay-today": {
        color: turquoise.main,
        border: "none",

        "&.Mui-selected": {
          color: white.main
        },

        "&:hover": {
          color: turquoise.main
        }
      }
    }
  }
});
